import React, { useEffect, useState } from 'react';

let listeners: ((msg: string, type: 'success' | 'error') => void)[] = [];

export function showToast(msg: string, type: 'success' | 'error' = 'success') {
  listeners.forEach(fn => fn(msg, type));
}

export function Toaster() {
  const [toast, setToast] = useState<{ msg: string; type: 'success' | 'error' } | null>(null);
  useEffect(() => {
    const handler = (msg: string, type: 'success' | 'error') => {
      setToast({ msg, type });
      setTimeout(() => setToast(null), 3500);
    };
    listeners.push(handler);
    return () => {
      listeners = listeners.filter(fn => fn !== handler);
    };
  }, []);
  if (!toast) return null;
  return (
    <div
      className={`fixed top-6 right-6 z-[9999] px-6 py-3 rounded-xl shadow-lg font-semibold text-base transition-all duration-300
        ${toast.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`}
      style={{ minWidth: 220, maxWidth: 400 }}
    >
      {toast.msg}
    </div>
  );
}

export function useToaster(setter: (msg: string, type: 'success' | 'error') => void) {
  useEffect(() => {
    listeners.push(setter);
    return () => {
      listeners = listeners.filter(fn => fn !== setter);
    };
  }, [setter]);
}
